import { render, staticRenderFns } from "./payment-detail.vue?vue&type=template&id=9c7ce450&"
import script from "./payment-detail.vue?vue&type=script&lang=js&"
export * from "./payment-detail.vue?vue&type=script&lang=js&"
import style0 from "./payment-detail.vue?vue&type=style&index=0&id=9c7ce450&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports